import {BulkSplitViewEntries} from '@webmate-web-core/shared/components/split-view/interfaces/split-view.interface';
import {ChangeDetectorRef, Directive, EventEmitter, Input, Output} from '@angular/core';
import {WmNotificationService} from '@webmate-web-core/shared/components/notification/wm-notification.service';

@Directive() // required to allow @Input() decorator in asbtract class
export abstract class SharedEntryListComponent<T> extends BulkSplitViewEntries<T> {

    @Input() compareKey: keyof T | ((e: T) => string) = 'id' as keyof T;

    // Emits the entity that just has been deactivated to be able
    // to react to this event on a higher level
    @Output() entityDeactivated: EventEmitter<T> = new EventEmitter<T>();

    private _entities: T[];

    set entities(e: T[]) {
        this._entities = e;
        if (this._entities.length > 0) {
            if (!this.detailView.entity) {
                // No entity was selected before, select the first one
                this.detailView.entity = this._entities[0];
            } else if (!this._entities.map(e => this.getCompareValue(e)).includes(this.getCompareValue(this.detailView.entity))) {
                // The entity that was displayed is not part of the list anymore. Show the first one
                // Ignore the modified check, because if the entity was modified, the filter could not change,
                // meaning the change comes from an actual change of the data
                this.detailView.entity = this._entities[0];
            } else {
                // The entity is still present in the list, select it again
                if (this.detailView.canDeactivate()) {
                    // there were no changes in the details view
                    this.detailView.entity = this._entities.find(e => this.getCompareValue(e) === this.getCompareValue(this.detailView.entity))!;
                }
                // Don't change the entity in the else case, otherwise the changes would be lost
            }

            if (this.bulkModeActive) {
                // Filter selected bulk entities that are no longer visible
                this.selecedEntities = this.selecedEntities.filter(s => this._entities.find(e => this.getCompareValue(e) === this.getCompareValue(s)));
            }
        }

        this.cdRef.markForCheck();
    }

    get entities() {
        return this._entities;
    }

    private _bulkModeActive: boolean = false;

    set bulkModeActive(b: boolean) {
        this._bulkModeActive = b;
        if (!b) {
            this.selecedEntities = [];
        }
        this.cdRef.markForCheck();
    }

    get bulkModeActive() {
        return this._bulkModeActive;
    }

    private _selecedEntities: T[] = [];

    set selecedEntities(a: T[]) {
        this._selecedEntities = a;
        this.bulkDetails.selectedEntities = this._selecedEntities;
        this.cdRef.markForCheck();
    }

    get selecedEntities() {
        return this._selecedEntities;
    }

    constructor(protected cdRef: ChangeDetectorRef, protected notificationService: WmNotificationService) {
        super();
    }

    selectEntry(e: T) {
        if (this.bulkModeActive) {
            this.toggleEntity(e);
            return;
        }

        if (this.detailView.entity && this.getCompareValue(e) === this.getCompareValue(this.detailView.entity)) {
            return;
        }

        const callback = () => {
            this.entityDeactivated.emit(this.detailView.entity);
            this.detailView.entity = e;
            this.cdRef.markForCheck();
        }

        if (this.detailView.canDeactivate()) {
            callback();
        } else {
            this.notificationService.open('There are unsaved changes', 'Review Changes', () => {
            }, 'Discard Changes', () => {
                callback();
            });
        }
    }

}
